module.exports = __webpack_public_path__ + "images/417ce8fce1cb12a5beb85985606960c3.png";